import styled from "styled-components";

export const CheckboxesStyled = styled.div`
  padding-inline-start: 12px;
`;
export const WeekdaysStyled = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  gap: 10px;
`;
